module.exports = __webpack_public_path__ + "img/bg-3-5.55750c5e.png";